import axios from 'axios';

import { tecDocUrl, PROVIDER_ID, basicAuth } from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';

export const getProductPartList = (articleId, articleCountry, targetType) => {
  return axios.post(
    tecDocUrl,
    {
      getArticlePartList: {
        articleCountry: articleCountry,
        articleId,
        linkingTargetType: targetType,
        lang: langCode,
        provider: PROVIDER_ID,
      },
    },
    { headers: basicAuth }
  );
};



// WEBPACK FOOTER //
// ./src/utils/getProductPartsList.js